import { accessAllTariffPlansList, accessLightAndStandardPlansList } from 'constants/accessPlanLists';
import { IPdfTitlePageSection, PDF } from 'constants/businessToolSections';
import {
  IForBankSections,
  FOR_BANK_SECTIONS as S,
  FOR_BANK_SUB_SECTIONS as SS,
} from 'constants/businessToolSections/forBank';

import { ISectionAccess } from './interface';

type IAccessibilityRules = {
  [K in IForBankSections | IPdfTitlePageSection]: ISectionAccess;
};

export const forBankAccessibilityRules: IAccessibilityRules = {
  [PDF.TITLE_PAGE_AND_TABLE_OF_CONTENTS]: {
    _accessPlan: accessAllTariffPlansList,
  },
  [S.OVERVIEW]: {
    _accessPlan: accessAllTariffPlansList,

    [SS.FOR_BANK_OVERVIEW.COMPANY]: accessAllTariffPlansList,
    [SS.FOR_BANK_OVERVIEW.PROJECT]: accessAllTariffPlansList,
    [SS.FOR_BANK_OVERVIEW.MARKET_CUSTOMERS]: accessAllTariffPlansList,
    [SS.FOR_BANK_OVERVIEW.FINANCIAL_INFO]: accessAllTariffPlansList,
    [SS.FOR_BANK_OVERVIEW.FUNDING_NEEDS]: accessAllTariffPlansList,
  },
  [S.EXECUTIVE_SUMMARY]: {
    _accessPlan: accessAllTariffPlansList,

    [SS.FOR_BANK_EXECUTIVE_SUMMARY.GOALS_AND_OBJECTIVES]: accessAllTariffPlansList,
    [SS.FOR_BANK_EXECUTIVE_SUMMARY.COMPANY_DESCRIPTION]: accessAllTariffPlansList,
    [SS.FOR_BANK_EXECUTIVE_SUMMARY.PRODUCTS_OR_SERVICES]: accessAllTariffPlansList,
    [SS.FOR_BANK_EXECUTIVE_SUMMARY.MARKET_AND_CUSTOMERS]: accessAllTariffPlansList,
    [SS.FOR_BANK_EXECUTIVE_SUMMARY.ORGANIZATION_AND_TEAM]: accessAllTariffPlansList,
    [SS.FOR_BANK_EXECUTIVE_SUMMARY.FINANCIAL_INFORMATION]: accessAllTariffPlansList,
    [SS.FOR_BANK_EXECUTIVE_SUMMARY.FINANCING_NEEDS]: accessAllTariffPlansList,
    [SS.FOR_BANK_EXECUTIVE_SUMMARY.RISKS]: accessAllTariffPlansList,
  },
  [S.ABOUT_COMPANY]: {
    _accessPlan: accessAllTariffPlansList,

    [SS.FOR_BANK_ABOUT_COMPANY.GENERAL_INFO]: accessAllTariffPlansList,
    [SS.FOR_BANK_ABOUT_COMPANY.COMPANY_HISTORY]: accessAllTariffPlansList,
    [SS.FOR_BANK_ABOUT_COMPANY.MISSION_AND_STRATEGY]: accessAllTariffPlansList,
    [SS.FOR_BANK_ABOUT_COMPANY.SWOT]: accessAllTariffPlansList,
  },
  [S.PRODUCTS_AND_SERVICES]: {
    _accessPlan: accessLightAndStandardPlansList,

    [SS.FOR_BANK_PRODUCTS_AND_SERVICES.DESCRIPTION]: accessLightAndStandardPlansList,
    [SS.FOR_BANK_PRODUCTS_AND_SERVICES.ADVANTAGES]: accessLightAndStandardPlansList,
    [SS.FOR_BANK_PRODUCTS_AND_SERVICES.R_AND_D]: accessLightAndStandardPlansList,
    [SS.FOR_BANK_PRODUCTS_AND_SERVICES.DELIVERY_AND_SUPPORT]: accessLightAndStandardPlansList,
  },
  [S.MARKET_ANALYSIS]: {
    _accessPlan: accessLightAndStandardPlansList,

    [SS.FOR_BANK_MARKET_ANALYSIS.MARKET_OVERVIEW]: accessLightAndStandardPlansList,
    [SS.FOR_BANK_MARKET_ANALYSIS.CONSUMER_NEEDS]: accessLightAndStandardPlansList,
    [SS.FOR_BANK_MARKET_ANALYSIS.COMPETITIVE_ANALYSIS]: accessLightAndStandardPlansList,
  },
  [S.MARKETING_AND_SALES]: {
    _accessPlan: accessLightAndStandardPlansList,

    [SS.FOR_BANK_MARKETING_AND_SALES.SALES_PLAN]: accessLightAndStandardPlansList,
    [SS.FOR_BANK_MARKETING_AND_SALES.MARKETING_PLAN]: accessLightAndStandardPlansList,
  },
  [S.BUSINESS_OPERATIONS]: {
    _accessPlan: accessLightAndStandardPlansList,

    [SS.FOR_BANK_BUSINESS_OPERATIONS.LOCATION_AND_PREMISES]: accessLightAndStandardPlansList,
    [SS.FOR_BANK_BUSINESS_OPERATIONS.EQUIPMENT]: accessLightAndStandardPlansList,
    [SS.FOR_BANK_BUSINESS_OPERATIONS.ASSETS]: accessLightAndStandardPlansList,
    [SS.FOR_BANK_BUSINESS_OPERATIONS.TECHNOLOGICAL_PROCESS]: accessLightAndStandardPlansList,
    [SS.FOR_BANK_BUSINESS_OPERATIONS.WORKING_RESOURCES]: accessLightAndStandardPlansList,
    [SS.FOR_BANK_BUSINESS_OPERATIONS.PARTNERS]: accessLightAndStandardPlansList,
    [SS.FOR_BANK_BUSINESS_OPERATIONS.PRODUCTION]: accessLightAndStandardPlansList,
    [SS.FOR_BANK_BUSINESS_OPERATIONS.QUALITY]: accessLightAndStandardPlansList,
  },
  [S.MANAGEMENT_AND_ORGANIZATION]: {
    _accessPlan: accessLightAndStandardPlansList,

    [SS.FOR_BANK_MANAGEMENT_AND_ORGANIZATION.MANAGEMENT_TEAM]: accessLightAndStandardPlansList,
    [SS.FOR_BANK_MANAGEMENT_AND_ORGANIZATION.EXTERNAL_PARTNERS_AND_ADVISERS]: accessLightAndStandardPlansList,
    [SS.FOR_BANK_MANAGEMENT_AND_ORGANIZATION.STAFF_ORGANIZATION]: accessLightAndStandardPlansList,
  },
  [S.IMPLEMENTATION_PLAN]: {
    _accessPlan: accessLightAndStandardPlansList,
  },
  [S.RAISING_AND_ALLOCATING_FUNDS]: {
    _accessPlan: accessLightAndStandardPlansList,
  },
  [S.LEGAL_FRAMEWORKS_AND_RISKS]: {
    _accessPlan: accessLightAndStandardPlansList,
  },
  [S.FINANCIAL_PLAN]: {
    _accessPlan: accessLightAndStandardPlansList,

    [SS.FOR_BANK_FINANCIAL_PLAN.KEY_ASSUMPTIONS]: accessLightAndStandardPlansList,
    [SS.FOR_BANK_FINANCIAL_PLAN.REVENUE_PLAN]: accessLightAndStandardPlansList,
    [SS.FOR_BANK_FINANCIAL_PLAN.PLANNED_EXPENSES]: accessLightAndStandardPlansList,
    [SS.FOR_BANK_FINANCIAL_PLAN.PROFIT_AND_LOSS_PROJECTION]: accessLightAndStandardPlansList,
    [SS.FOR_BANK_FINANCIAL_PLAN.CASH_FLOW_ELEMENTS]: accessLightAndStandardPlansList,
    [SS.FOR_BANK_FINANCIAL_PLAN.FINANCIAL_PERFORMANCE]: accessLightAndStandardPlansList,
    [SS.FOR_BANK_FINANCIAL_PLAN.OPENING_BALANCE_SHEETS]: accessLightAndStandardPlansList,
    [SS.FOR_BANK_FINANCIAL_PLAN.PROJECTED_BALANCE_SHEETS]: accessLightAndStandardPlansList,
    [SS.FOR_BANK_FINANCIAL_PLAN.PROJECTED_CASH_FLOW]: accessLightAndStandardPlansList,
  },
};
